module.exports = __webpack_public_path__ + "static/media/k6.56ecce16.jpg";